<template>
  <div v-show="show" class="invalid-feedback">
    <img 
      src="@/assets/images/trips/impacts.png" 
      class="exclamation" 
      width="16" 
      height="16" 
      alt="Error" 
    />
    {{ message }}
  </div>
</template>

<script>
export default {
  name: "ValidationFeedback",
  props: {
    show: {
      type: Boolean,
      required: true
    },
    message: {
      type: String,
      required: true
    }
  }
};
</script>